const Config = {
  //  base_url: "https://us-central1-playftdev.cloudfunctions.net/", //develop
  base_url: "https://us-central1-playftstaging.cloudfunctions.net/", //staging
  //base_url: "https://us-central1-playfuturetraders.cloudfunctions.net/", //production

  // APP_NAME:"PLAYFUTURETRADERS",
  APP_NAME:"ODU"
};
export default Config;
